import clsx from 'clsx';
import Button from 'components/Button';
import Panel from 'components/Panel';
import DocumentInformation from 'pages/Portal/components/Inbox/DocumentInformation';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {useBackend} from 'state/backend';

import {ClientInboxItemBackend} from '../../types';

interface InfoPanelProps {
    isZipFile: boolean;
}

const InfoPanel: FC<InfoPanelProps> = ({isZipFile}) => {
    const {
        data: {document, partnerName, portalMid},
    } = useBackend<ClientInboxItemBackend>();
    const {t} = useTranslation('Portal');

    return (
        <Panel
            title={
                isZipFile
                    ? t('clientInboxItem.infoPanel.zipTitle', {
                          partnerName,
                      })
                    : t('clientInboxItem.infoPanel.title')
            }
        >
            <DocumentInformation document={document} isZipFile={isZipFile} />
            <div
                className={clsx(
                    'mt-4 grid gap-4',
                    isZipFile ? 'grid-cols-1' : 'grid-cols-2',
                )}
            >
                {!isZipFile && (
                    <Button
                        className="flex-1"
                        kind="secondary"
                        onClick={() => {
                            const newWindow: null | Window = window.open(
                                `/portal/${portalMid}/client-inbox/file-download/${document.mid}/?fmt=pdf`,
                            );

                            if (newWindow) {
                                newWindow.opener = null;
                            }
                        }}
                        rel="noopener noreferrer"
                        size="base"
                    >
                        {t('clientInboxItem.infoPanel.view')}
                    </Button>
                )}
                <Button
                    className="flex-1"
                    icon="download"
                    kind="primary"
                    onClick={() => {
                        const newWindow: null | Window = window.open(
                            `/portal/${portalMid}/client-inbox/file-download/${document.mid}/`,
                        );

                        if (newWindow) {
                            newWindow.opener = null;
                        }
                    }}
                    rel="noopener noreferrer"
                    size="base"
                >
                    {t('clientInboxItem.infoPanel.download')}
                </Button>
            </div>
        </Panel>
    );
};

export default InfoPanel;
